<div class="items-list">
  <h4>{{'ITEM.DETAIL.NEIGHBOURS' | translate}}</h4>

  @if (!isLoading && neighbours?.length === 0) {
    <span>
      {{ 'ITEM.DETAIL.NO_NEIGHBOURS' | translate}}
    </span>
  }

  @if (isLoading) {
    <div class="d-flex justify-content-center"
      >
      <mat-spinner class="mb-3"
      [diameter]="32"></mat-spinner>
    </div>
  }

  @for (item of neighbours; track item) {
    <mpa-linked-item-row
      [showDeleteButton]="false"
      size="big"
      [isHighlighted]="item.id === selectedItem.id"
    [item]="item"></mpa-linked-item-row>
  }
</div>